var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
export function renderText(text) {
    var regex = text.match(
    // eslint-disable-next-line
    /(https?|file):\/\/[a-zA-Z0-9\/:%#&~=_!'\$\?\(\)\.\+\*\-]+|(^|\n)\\\\[^<>{}"`|\^\[\]\r\n]+/g);
    if (!regex) {
        return text;
    }
    var results = [text];
    regex.forEach(function (url, idx) {
        if (url[0] === '\n')
            url = url.substring(1);
        var href = url;
        if (/^\\\\/.test(url)) {
            href = 'file:' + encodeURI(url.replace(/\\/g, '/'));
        }
        var target = results.pop();
        if (target && typeof target === 'string') {
            var items = target.split(url);
            results = __spreadArray(__spreadArray([], results, true), [
                items[0],
                _jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", children: url }, idx),
                items.slice(1).join(url),
            ], false).filter(function (e) { return !!e; });
        }
    });
    return results;
}
//# sourceMappingURL=renderText.js.map